import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_2 = {
  key: 0,
  class: "required-input"
}
const _hoisted_3 = { class: "ml-auto" }
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "required-input"
}
const _hoisted_6 = {
  key: 1,
  class: "error-text"
}

import { computed, onUnmounted, ref } from 'vue';
import { FieldValidationResult, ERROR_ANCHOR_CLASS, FORM_BLUR_EVENT } from './FormValidation';
import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'FormField.vue3',
  props: {
    labelKey: {},
    labelFor: {},
    validationState: {},
    appendLabel: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    required: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const inputBlurredWithError = ref(false);

const showValidationMessage = computed(() => 
    !!props.validationState?.invalid && (inputBlurredWithError.value || props.validationState?.submitAttempted));

const fieldClass = computed(() => 
    ({[ERROR_ANCHOR_CLASS]: showValidationMessage.value, field: true, 'mb-0': props.inline, 'flex': props.appendLabel})
);

function onBlur() {
    dispatchEvent(new Event(FORM_BLUR_EVENT))

    requestAnimationFrame(() => {
        if (props.validationState?.invalid === true) 
            inputBlurredWithError.value = true;
    });
}

onUnmounted(() => {
    removeEventListener(FORM_BLUR_EVENT, onBlur);
})


return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(fieldClass.value)
  }, [
    (_ctx.labelKey && !_ctx.appendLabel)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_unref(t)(_ctx.labelKey)) + " ", 1),
          (props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, [
            _renderSlot(_ctx.$slots, "action")
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      _renderSlot(_ctx.$slots, "default", { onBlur: onBlur }),
      (_ctx.labelKey && _ctx.appendLabel)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: "ml-2 cursor-pointer",
            for: props.labelFor
          }, [
            _createTextVNode(_toDisplayString(_unref(t)(_ctx.labelKey)) + " ", 1),
            (props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "*"))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4))
        : _createCommentVNode("", true)
    ])), [
      [
        _directive_tooltip,
        { value: _ctx.validationState?.message, disabled: !showValidationMessage.value || !_ctx.inline },
        void 0,
        { bottom: true }
      ]
    ]),
    (showValidationMessage.value && !_ctx.inline)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.validationState?.message), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})